import { useMutation } from "react-query";
import http from "infra/http";
import { useCurrentTenant } from "core/features/auth/tenant.store";

function useDeleteCentroDeCusto(tenantId?: string) {
  const { tenant } = useCurrentTenant();
  const _tenantId = tenantId || tenant.id;

  return useMutation(
    `/v1/tenants/${_tenantId}/centro-de-custo/:id`,
    (id: string) => {
      const apiRoute = `/v1/tenants/${_tenantId}/centro-de-custo/${id}`;

      return http.delete(apiRoute, { params: _tenantId });
    },
    {
      retry: false,
    }
  );
}

export default useDeleteCentroDeCusto;
